import { render, staticRenderFns } from "./jingxiu.vue?vue&type=template&id=4889d622"
import script from "./jingxiu.vue?vue&type=script&lang=js"
export * from "./jingxiu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports